/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actuator_Type_Recycle_PumpInputs */



/**
* | output |
* | --- |
* | "Recycle pump" |
*
* @param {Actuator_Type_Recycle_PumpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const actuator_type_recycle_pump = /** @type {((inputs?: Actuator_Type_Recycle_PumpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actuator_Type_Recycle_PumpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recycle pump")
	return /** @type {LocalizedString} */ ("Pompe de recyclage")
});